import styled from 'styled-components'
import { floatingMenu } from 'styles'
import { Flex } from 'components'

export const Modal = styled(Flex)`
  transition: 0.25s;
  overflow-y: auto;
  ${floatingMenu}
`
